import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", to: "/#home" },
  { label: "About", to: "/#about" },
  { label: "Practice", to: "/#practice" },
  { label: "Insights", to: "/#insights" },
  { label: "Contact", to: "/#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  const handleNav = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      if (loc.pathname !== "/") { nav("/"); setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200); }
      else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else { nav(to); }
  };

  return (
    <>
      <motion.nav
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 0.2 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/5" : "bg-transparent"}`}
        data-testid="main-nav"
      >
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
          <Link to="/" className="flex flex-col leading-none" data-testid="brand-logo">
            <span className="font-serif-display text-3xl md:text-4xl text-[#C8A45D] tracking-tight">H.P.</span>
          </Link>
          <div className="hidden md:flex items-center gap-10">
            {links.map((l) => (
              <button key={l.label} onClick={() => handleNav(l.to)} className="nav-link" data-testid={`nav-${l.label.toLowerCase()}`}>{l.label}</button>
            ))}
          </div>
          <button className="md:hidden text-white" onClick={() => setOpen(true)} data-testid="mobile-menu-btn"><Menu size={22}/></button>
        </div>
      </motion.nav>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[70] bg-black/95 backdrop-blur-2xl md:hidden flex flex-col" data-testid="mobile-menu">
            <div className="flex justify-between items-center px-6 py-5 border-b border-white/5">
              <span className="font-cinzel text-[10px] tracking-[0.35em] text-[#C8A45D]">NEXUS LEGAL</span>
              <button onClick={() => setOpen(false)} className="text-white" data-testid="mobile-menu-close"><X size={22}/></button>
            </div>
            <div className="flex flex-col gap-6 p-8 mt-4">
              {links.map((l, i) => (
                <motion.button
                  key={l.label}
                  initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 * i }}
                  onClick={() => handleNav(l.to)}
                  className="text-left font-serif-display text-3xl text-white/90 hover:text-[#C8A45D] transition-colors"
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                >{l.label}</motion.button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
